export default __webpack_public_path__ + "static/media/aspen_digital_logo.0b8d2a1b.webp";